import {
  SolutionType,
  SOLUTION_TYPE,
} from '../../../../shared/constants/user-info/solutionType';
import { getHumanizeSolutionType } from '../../../../shared/utils/userInfoUtils/getHumanizeSolutionType/getHumanizeSolutionType';

export const renderSolutionsValue = (solutions: SolutionType[]): string => {
  if (!solutions || solutions.length === 0) return '';

  // Filter out CHALLENGE as it's a hidden solution option
  const visibleSolutions = solutions.filter(
    (solution) => solution !== SOLUTION_TYPE.CHALLENGE,
  );

  return visibleSolutions
    .map((solution) => getHumanizeSolutionType(solution))
    .join(' & ');
};
